import React, { Component } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { theme, themeClass } from '../../constants/styling/themes';
import { map, filter, without, noop } from 'lodash';
import Checkbox from './Checkbox';

const FORCE_OPEN_CLASS = 'ckp-js-select-force-open';
const FORCE_ACTION_CLASS = 'ckp-js-select-force-action';

// TODO-NT Better grouped by select field

class SelectField extends Component {
    constructor(props) {
        super(props);
        this.state = { open: false, query: '' };
        this.searchInputRef = React.createRef();
    }
    _onChange = ev => {
        const value = this.props.multiple ? without(ev.target.value, undefined, null) : ev.target.value;
        ev.target.value !== undefined && this.props.onChange(value, ev.target.name);
    };
    _onOpen = () => {
        this.setState({ open: true });
        setTimeout(() => this.searchInputRef.current && this.searchInputRef.current.focus(), 100);
    };
    _onClose = ev => {
        const targetName = ev.target.getAttribute('name');
        if (targetName !== FORCE_OPEN_CLASS) {
            targetName === FORCE_ACTION_CLASS && this.props.action();
            this.setState({ open: false });
            setTimeout(() => this.setState({ query: '' }), 100);
        }
    };
    _renderValue = value => {
        let items = [];
        if (this.props.grouped) {
            map(this.props.items, (v, k) => {
                items = items.concat(v);
            });
        } else {
            items = this.props.items;
        }
        return this.props.multiple
            ? (filter(items, i => value.includes(i.value)) || []).map(x => x.label).join(', ')
            : (filter(items, i => i.value === value)[0] || {}).label || value;
    };
    _search = e => this.setState({ query: e.target.value });
    _applySearch = items =>
        filter(items, i => i.label && i.label.toLowerCase().includes(this.state.query.toLowerCase()));
    _selectAll = () => {
        if (this.props.value.length) {
            this.props.onChange([], this.props.name);
        } else {
            this.props.onChange(
                this.props.items.map(x => x.value),
                this.props.name
            );
        }
    };
    _selectItem = item => (
        <MenuItem className="ckp-selects-menu-item" key={item.value} value={item.value}>
            {this.props.multiple ? (
                <Checkbox name={item.value} onChange={noop} checked={this.props.value.includes(item.value)} />
            ) : null}
            {item.label}
        </MenuItem>
    );
    render() {
        const items = map(
            !this.props.grouped && this.props.withSearch ? this._applySearch(this.props.items) : this.props.items,
            item =>
                this.props.grouped
                    ? map(this.props.grouped && this.props.withSearch ? this._applySearch(item) : item, i =>
                          this._selectItem(i)
                      )
                    : this._selectItem(item)
        );
        return (
            <div
                className={`ckp-selects ckp-forms-element ${themeClass(this.props.theme)} ${
                    this.props.className ? this.props.className : ''
                } ${this.props.disabled ? 'is-disabled' : ''}${this.props.error ? 'is-error' : ''}`}
            >
                <MuiThemeProvider theme={theme(this.props.theme)}>
                    <FormControl error={!!this.props.error} fullWidth>
                        <InputLabel htmlFor={this.props.id}>{this.props.label}</InputLabel>
                        <Select
                            open={this.state.open}
                            onOpen={this._onOpen}
                            onClose={this._onClose}
                            displayEmpty={this.props.displayEmpty}
                            value={this.props.value || ''}
                            onChange={this._onChange}
                            disabled={this.props.disabled}
                            multiple={this.props.multiple}
                            title={this.props.value}
                            inputProps={{
                                name: this.props.name,
                                id: this.props.id
                            }}
                            renderValue={this._renderValue}
                            input={<Input fullWidth name={this.props.name} value={this.props.value} />}
                            MenuProps={{ classes: { paper: 'ckp-selects-menu' } }}
                        >
                            {(this.props.action
                                ? [
                                      <span
                                          key="ckp-selects-action-key"
                                          name={FORCE_ACTION_CLASS}
                                          className="ckp-selects-action is-add"
                                      >
                                          {this.props.actionLabel}
                                      </span>
                                  ]
                                : []
                            )
                                .concat(
                                    this.props.withSearch
                                        ? [
                                              <input
                                                  ref={this.searchInputRef}
                                                  key="ckp-selects-search-field-key"
                                                  autoComplete="off"
                                                  onChange={this._search}
                                                  className="ckp-selects-search-field"
                                                  placeholder="SEARCH..."
                                                  name={FORCE_OPEN_CLASS}
                                                  type="text"
                                              />
                                          ]
                                        : []
                                )
                                .concat(
                                    this.props.multiple && !filter(this.props.items, x => !x.value).length
                                        ? [
                                              <div key="ckp-selects-select-all-key" className="ckp-selects-select-all">
                                                  <Checkbox
                                                      name={`select-all-${this.props.name}`}
                                                      checked={this.props.items.length === this.props.value.length}
                                                      halfChecked={this.props.value.length}
                                                      onChange={this._selectAll}
                                                      label={this.props.value.length ? 'Unselect all' : 'Select all'}
                                                  />
                                              </div>
                                          ]
                                        : []
                                )
                                .concat(items)}
                        </Select>
                        {this.props.error ? <p className="ckp-selects-error-message">{this.props.error}</p> : null}
                    </FormControl>
                </MuiThemeProvider>
            </div>
        );
    }
}

SelectField.defaultProps = { withSearch: true, items: [], actionLabel: 'Create', value: '', displayEmpty: true };

export default SelectField;



// WEBPACK FOOTER //
// ./src/components/forms/SelectField.js